import { __rest } from "tslib";
import { createElement } from 'rax';
import { FieldElement } from '../field';
import Upload from '../upload';
export default class UploadField extends FieldElement {
    getProps() {
        return Object.assign(Object.assign({}, super.getProps()), { embedded: true });
    }
    renderControl() {
        const _a = this.getProps(), { embedded } = _a, others = __rest(_a, ["embedded"]);
        return <Upload {...others}/>;
    }
}
UploadField.displayName = 'UploadField';
